import React, {Fragment} from 'react';
import ScrollUpButton from 'react-scroll-up-button';
import ImageButton from '../assets/img/back-top.png';

class ScrollTopButton extends React.Component {
    render() {
        return (
            <ScrollUpButton
                ContainerClassName="ScrollUpButtonContainer"
                TransitionClassName="ScrollUpButtonToggled">
                <img src={ImageButton} alt="Scroll to top" />
            </ScrollUpButton>
        )
    }
}

export default ScrollTopButton;


// WEBPACK FOOTER //
// ./src/features/Layout/components/ScrollTopButton.js